import React from "react";
import styled from "styled-components";

interface InputProps {
  label: string;
  value?: string;
  placeholder?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  hasError?: boolean;
  disabled?: boolean;
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  width: 100%;
`;

const Label = styled.label`
  font-size: 12px;
  color: #5e6366;
  margin-bottom: 5px;
  font-family: "Mont", sans-serif;
`;

export const StyledInput = styled.input<{ hasError?: boolean }>`
  padding: 10px;
  font-size: 16px;
  border: 1px solid ${(props) => (props.hasError ? "#ff0000" : "#cfd3d4")};
  border-radius: 8px;
  color: ${(props) => (props.hasError ? "#ff0000" : "#5e6366")};
  font-family: "Mont", sans-serif;
  text-align: left;
  &:focus {
    border-color: ${(props) => (props.hasError ? "#ff0000" : "#5570f1")};
  }
`;

const Input: React.FC<InputProps> = ({
  label,
  value,
  onChange,
  placeholder,
  hasError,
  disabled = false,
}) => {
  return (
    <Container>
      <Label htmlFor="input-text">{label}</Label>
      <StyledInput
        id="input-text"
        value={value}
        onChange={onChange}
        placeholder={placeholder ? placeholder : ""}
        hasError={hasError}
        disabled={disabled}
      />
    </Container>
  );
};

export default Input;
